const width = (state = window.innerWidth, action) => {
    switch(action.type) {
        case 'width':
            return action.payload;
        default:
            return state;
    }
}

export default width;